import { c as _c } from "react/compiler-runtime";
import type { EmoticonItem } from '@module/apis/client-side/guide/type';
import SettingConfig from '@module/config/setting';
import daysUntil from '@module/utils/date/daysUntil';
import BaseLottie from '../lottie/BaseLottie';
interface EmoticonListItemProps {
  item: EmoticonItem;
  isClicked?: boolean;
  onClick?: () => void;
  onBlur?: () => void;
}
function EmoticonListItem(t0) {
  const $ = _c(24);
  const {
    item,
    isClicked: t1,
    onClick,
    onBlur
  } = t0;
  const isClicked = t1 === undefined ? false : t1;
  const shouldShowAnimation = item.animYN === "Y" && isClicked;
  const isDday = item.endDateTime && item.endDateTime !== "0000-00-00 00:00:00";
  let t2;
  if ($[0] !== item.wImgUrl || $[1] !== shouldShowAnimation) {
    t2 = !shouldShowAnimation && item.wImgUrl && <img src={item.wImgUrl} alt="emo" className="h-full" />;
    $[0] = item.wImgUrl;
    $[1] = shouldShowAnimation;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.wAnimUrl || $[4] !== shouldShowAnimation) {
    t3 = shouldShowAnimation && <BaseLottie src={item.wAnimUrl} renderer="canvas" />;
    $[3] = item.wAnimUrl;
    $[4] = shouldShowAnimation;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onBlur || $[7] !== onClick || $[8] !== t2 || $[9] !== t3) {
    t4 = <button className="flex h-[180px] w-[200px] justify-center" onClick={onClick} onBlur={onBlur}>{t2}{t3}</button>;
    $[6] = onBlur;
    $[7] = onClick;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/tiny_heart.png`} alt="heart" className="w-[16px]" />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== item.heart) {
    t6 = <div className="mt-1 flex items-center gap-1">{t5}<span className="text-baseFg text-sm">{item.heart}</span></div>;
    $[12] = item.heart;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isDday || $[15] !== item.endDateTime) {
    t7 = isDday && <p className="text-[#777]">{daysUntil(item.endDateTime)}일남음</p>;
    $[14] = isDday;
    $[15] = item.endDateTime;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== item.userNick) {
    t8 = item.userNick && <p className="text-[#777]">{item.userNick}</p>;
    $[17] = item.userNick;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className="mb-12 flex w-fit flex-col items-center">{t4}{t6}{t7}{t8}</div>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export default EmoticonListItem;